import styles from './SportsHeader.module.css';
import classNames from 'classnames';
import { getDefaultSportIconSrc } from 'helpers/sportIcon';
import { SportIcon } from 'components/ThemeIcon/SportIcon';
import { ThemeIcon } from 'components/ThemeIcon/ThemeIcon';
import type { ThemeIconKey } from 'lib/themeIcons';

interface Props {
  sportId?: number;
  iconOverrideKey?: ThemeIconKey;
  title: string;
  count: number;
  expanded: boolean;
}

export const SportsHeader = ({
  sportId,
  iconOverrideKey,
  title,
  count,
  expanded,
}: Props) => {
  return (
    <div className={styles.wrapper}>
      <div>
        {iconOverrideKey ? (
          <ThemeIcon
            icon={iconOverrideKey}
            alt={title}
            variant="inline"
            tone="chrome"
          />
        ) : sportId ? (
          <SportIcon
            sportId={sportId}
            tone="chrome"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = getDefaultSportIconSrc();
            }}
            alt={title}
          />
        ) : (
          <ThemeIcon
            icon="highlights"
            alt={title}
            variant="inline"
            tone="chrome"
          />
        )}
        {title}
      </div>
      <div>
        <div className={styles.count}>{count}</div>
        <div
          className={classNames(
            styles.icon,
            expanded ? styles.chevronDown : styles.chevronRight
          )}
        />
      </div>
    </div>
  );
};
